export default "__VITE_ASSET__C8zoe4bM__"